import BmSkipPaymentModal from './BmSkipPaymentModal.component';

export default BmSkipPaymentModal;
